module.exports = __webpack_public_path__ + "media/newstyle/images/hipercard-87945c46cb5a184fa2472bd80e2cbd39.svg";